'use strict';

const $ = require('jquery');
const _ = require('underscore');
const Mn = require('backbone.marionette');
const Route = require('common/route');
const Actions = require('common/domain/action/index');
const Dispatcher = require('common/domain/repository/dispatcher');
const TypeaheadView = require('common/ui/view/typeahead');
const ElementStore = require('system/domain/repository/element');
const NodeModel = require('system/domain/entity/node');

const ValueTypeSearchView = Mn.View.extend({
    template: false,
    initialize: function(params) {
        _.bindAll(this, 'find', 'update', 'enter');
        this._el = params.el;
        this._context = params.context;
        this.onSelect = params.onSelect;
    },

    onRender: function() {
        new TypeaheadView({
            minLength: 1,
            el: this._el,
            find: this.find,
            update: this.update,
            enter: this.enter,
            itemView: TypeaheadView.DropdownItemView.extend({
                template: _.template('<%-name%>')
            })
        });

        return this;
    },

    search: function(query) {
        return ElementStore.getValueTypes({
            context: this._context
        })
            .chain()
            .filter(function(n) {
                return n.get('name').toLowerCase()
                        .indexOf(query.toLowerCase()) > -1;
            })
            .map(function(n) {
                return n.clone();
            })
            .value();
    },

    find: function(query) {
        const deferred = $.Deferred();
        let values = this.search(query);
        const context = this._context;
        const path = Route.urlFor('api:project:search', this._context);
        $.ajax({
            url: `${path}?query=Record:type=ValueType&query=Record:name=${query}`,
            dataType: 'json'
        }).done(function(data) {
            values = _.union(values,
                _.chain(data['Record'])
                    .map(function(d){
                            return new NodeModel(d);
                        }
                    )
                    .value());

            Dispatcher.dispatch({
                type: Actions.MERGE_NODE,
                context: context,
                node: data['Record']
            });

            deferred.resolve(values);
        });
        return deferred.done;
    },

    update: function(valueType) {
        if(this.onSelect) {
            this.onSelect(valueType);
        }
        return '';
    },

    enter: function(query) {
        const valueTypes = this.search(query);
        if(valueTypes.length > 0) {
            if(this.onSelect) {
                this.onSelect(valueTypes[0]);
            }
        }
        return '';
    }
});

module.exports = ValueTypeSearchView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/value-type-search.js